import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook';

const FaceBook = () => {
    
    return (
        <div>
    <FacebookIcon color="primary" />
            FaceBook
        </div>
    )
}

export default FaceBook
